import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './list-of-numbers.component.scss';
var ListOfNumbers = /** @class */ (function (_super) {
    tslib_1.__extends(ListOfNumbers, _super);
    function ListOfNumbers(element) {
        return _super.call(this, element) || this;
    }
    ListOfNumbers.prototype.init = function () { };
    ListOfNumbers.prototype.bindEvents = function () { };
    return ListOfNumbers;
}(Base));
export { ListOfNumbers };



//////////////////
// WEBPACK FOOTER
// ./components/list-of-numbers/list-of-numbers.component.ts
// module id = 402
// module chunks = 0